export function goToEbooking(token: string): void {
  if (localStorage.getItem("preventDowngrade")) return;
  const { origin } = window.location;
  const url = `${origin.replace("eb.", "ebooking.")}#?auth=${token}`;
  window.location.href = url;
}
